import { render, staticRenderFns } from "./ChooseAlternative.vue?vue&type=template&id=b9ef51a6&scoped=true"
import script from "./ChooseAlternative.vue?vue&type=script&lang=js"
export * from "./ChooseAlternative.vue?vue&type=script&lang=js"
import style0 from "./ChooseAlternative.vue?vue&type=style&index=0&id=b9ef51a6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9ef51a6",
  null
  
)

export default component.exports